var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('managed-rule-group-statement',{attrs:{"value":_vm.statement.managed_rule_group_name,"ruleGroupId":_vm.statement.rule_group_id,"isEdit":_vm.isEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }